import { createFileRoute } from '@tanstack/react-router';

import { ensureRouteAccess } from '@/lib/auth/guards';

export const Route = createFileRoute('/(authenticated)/users/')({
	beforeLoad: ensureRouteAccess('/users'),
});
